import { useNavigate, useLocation } from "react-router-dom";
import Header from "../components/Header";

export default function Failed() {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get error data passed from EnterPin
  const { error, amount, cardId } = location.state || {};

  const handleRetry = () => {
    navigate(-2); // Go back 2 steps to EnterAmount
  };

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <div className="p-6 min-h-screen flex flex-col bg-gradient-to-b from-gray-900 to-gray-800 text-white">
      <Header />
      
      <div className="flex-1 flex flex-col items-center justify-center px-6 pb-12">
        {/* Error Icon */}
        <div className="mb-6">
          <div className="w-24 h-24 bg-red-500/20 rounded-full flex items-center justify-center border-4 border-red-500">
            <span className="text-6xl">✕</span>
          </div>
        </div>

        {/* Error Message */}
        <h1 className="text-3xl font-bold text-red-400 mb-2">
          Payment Failed
        </h1>
        <p className="text-gray-400 text-center mb-8 max-w-sm">
          We couldn't process your transaction
        </p>

        {/* Error Details */}
        <div className="w-full max-w-md bg-gray-800 rounded-2xl p-6 mb-6">
          {/* Amount */}
          {amount && (
            <div className="text-center mb-6 pb-6 border-b border-gray-700">
              <p className="text-gray-400 text-sm mb-2">Attempted Amount</p>
              <p className="text-3xl font-bold text-white">
                ${parseFloat(amount).toFixed(2)}
              </p>
              <p className="text-gray-400 text-xs mt-1">MUSD</p>
            </div>
          )}

          {/* Card ID */}
          {cardId && (
            <div className="mb-4">
              <p className="text-gray-400 text-xs mb-1">Card ID</p>
              <p className="text-white font-mono text-sm">{cardId}</p>
            </div>
          )}

          {/* Error Reason */}
          <div className="mb-4">
            <p className="text-gray-400 text-xs mb-1">Error</p>
            <p className="text-red-400 text-sm">
              {error?.error || error?.message || error || "Transaction failed"}
            </p>
          </div>
        </div>

        {/* Common Issues */}
        <div className="w-full max-w-md bg-red-500/10 border border-red-500/30 rounded-lg p-4 mb-6">
          <p className="text-red-200 text-xs mb-2 font-semibold">
            Common Issues:
          </p>
          <ul className="text-red-200 text-xs ml-4 list-disc space-y-1">
            <li>Incorrect PIN</li>
            <li>Insufficient card balance</li>
            <li>Daily limit exceeded</li>
            <li>Network connection issue</li>
          </ul>
        </div>

        {/* Action Buttons */}
        <div className="w-full max-w-md space-y-3">
          <button
            onClick={handleRetry}
            className="w-full bg-blue-600 hover:bg-blue-700 py-4 rounded-xl text-lg font-semibold shadow-lg transition"
          >
            Try Again
          </button>

          <button
            onClick={handleGoHome}
            className="w-full bg-gray-700 hover:bg-gray-600 py-3 rounded-xl text-sm font-semibold transition"
          >
            Go to Home
          </button>
        </div>
      </div>
    </div>
  );
}
